<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="mb-9">
          <div class="row">
            <div class="col-12 col-lg-10 mx-auto my-5"></div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-10 m-auto">
              <div class="card">
                <div
                  class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
                >
                  <div
                    class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 text-center"
                  >
                  <h5 class="font-weight-normal mt-3 text-white">Inserta nuevo ingreso</h5>
                  </div>
                </div>
                <div
                  class="p-4 border-radius-xl bg-white"
                >
                  <h5 class="font-weight-bolder mb-0">Introduzca su ingreso para el récord</h5>
                  <p class="mb-0 text-sm">Todos los campos son obligatorios</p>
                  <form id="nuevoIngresoForm">
                  <div class="multisteps-form__content">
                    <div class="row mt-3">
                      <div class="col-12 col-sm-6">
                        <material-input id="fechaIngreso" class="is-focused" :value="getTodayDate()" label="Fecha del ingreso" type="date" variant="dynamic" />
                      </div>
                      <div class="col-12 col-sm-6 mt-3 mt-sm-0">
                        <material-select id="tipoIngresoSelect" clazz="form-control" header="Tipo de ingreso" :choices="getTiposIngreso"></material-select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-sm-6">
                        <select
                          id="producto"
                          class="form-control"
                          name="producto"
                        >
                        <option value="">Producto o Servicio</option>
                          <option value="0">Producto 1</option>
                          <option value="1">Producto 2</option>
                          <option value="2">Producto 3</option>
                          <option value="3">Producto 4</option>
                          <option value="4">Producto 5</option>
                        </select>
                      </div>
                      <div class="col-12 col-sm-6 mt-3 mt-sm-0">
                        <select
                          id="medioPago"
                          class="form-control"
                          name="medioPago"
                        >
                        <option value="">Medio de pago</option>
                          <option value="0">SINPE Móvil</option>
                          <option value="1">Transferencia Bancaria</option>
                          <option value="2">Datáfono</option>
                          <option value="3">Efectivo</option>
                          <option value="4">Otros</option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-sm-6">
                        <material-input
                          id="monto"
                          type="number"
                          label="Monto"
                          disabled=""
                          variant="dynamic"
                        />
                      </div>
                    </div>
                    <div class="button-row d-flex mt-4">
                      <material-button
                        type="button"
                        color="dark"
                        variant="gradient"
                        class="ms-auto mb-0 js-btn-next"
                        required
                        @click="sendForm"
                        >Ingresar</material-button
                      >
                    </div>
                  </div>
                  </form>
                  <div class="table-responsive">
                    <table id="datatable-search" class="table table-flush">
                    </table>
                  </div>
                  <div class="position-fixed bottom-1 end-10 z-index-2">
                    <material-snackbar
                        v-if="snackbar === 'danger'"
                        title="Por favor complete formulario"
                        date=""
                        description="Por favor, debe completar todos los campos para poder continuar"
                        :icon="{ component: 'campaign', color: 'white' }"
                        color="danger"
                        :close-handler="closeSnackbar"
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialSelect from "@/components/MaterialSelect.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import Choices from "choices.js";
import { DataTable } from "simple-datatables";
import { mapGetters } from "vuex";

let dataTableSearch;

export default {
  name: "ControlIngresos",
  components: {
    MaterialInput,
    MaterialButton,
    MaterialSnackbar,
    MaterialSelect
  },
  data() {
    return {
      snackbar: null,
    };
  },
  computed: {
    ...mapGetters(['getTiposIngreso']),
    tiposIngresoOptions() {
      return this.getTiposIngreso
    }
  },
  created() {
    this.$store.dispatch('getTiposIngreso', 1)
  },
  beforeUnmount() {
  },
  
  mounted() {
    

    if (document.getElementById("producto")) {
      var element1 = document.getElementById("producto");
      new Choices(element1, {
        searchEnabled: false,
        placeholder: true,
        placeholderValue: "Producto o Servicio"
      });
    }

    if (document.getElementById("medioPago")) {
      var element2 = document.getElementById("medioPago");
      new Choices(element2, {
        searchEnabled: false,
        placeholder: true,
        placeholderValue: "Medio de pago"
      });
    }

    dataTableSearch = new DataTable("#datatable-search", {
      searchable: true,
      fixedHeight: true,
    });

    let headings = {
        headings: [
            "Fecha Ingreso",
            "Tipo de Ingreso",
            "Producto o Servicio",
            "Medio de pago",
            "Monto"
        ],
	      data: [
        
        ]
    };

    dataTableSearch.insert(headings);

    let data = {
      data: [
          "15/01/2024", "Venta", "Producto 1", "Tarjeta credito", "34232"
        ]
    }

    dataTableSearch.insert(data);


  },
  methods: {
    closeSnackbar() {
      this.snackbar = null;
    },
    getTodayDate() {
      return (new Date()).toISOString().split('T')[0];
    },
    sendForm() {
      this.snackbar = 'danger';
      setTimeout(() => this.snackbar = null , 5000)
    }
  }
};
</script>